export const ORG_STATUS = {
	0: 'All',
	1: 'Implementation',
	2: 'Live',
	3: 'Inactive',
	4: 'Dormant',
	5: 'Suspended',
	6: 'Acquired',
	ACQUIRED: 6,
	ALL: 0,
	DORMANT: 4,
	IMPLEMENTATION: 1,
	INACTIVE: 3,
	LIVE: 2,
	SUSPENDED: 5
};
